export const EVENT_VAL_ENTER_GAME = "EVENT_VAL_ENTER_GAME";
export const EVENT_VAL_EXIT_GAME = "EVENT_VAL_EXIT_GAME";
